import { render } from "./DynamicTable.vue?vue&type=template&id=fb897a44&scoped=true"
import script from "./DynamicTable.vue?vue&type=script&lang=js"
export * from "./DynamicTable.vue?vue&type=script&lang=js"

import "./DynamicTable.vue?vue&type=style&index=0&id=fb897a44&lang=scss"
import "./DynamicTable.vue?vue&type=style&index=1&id=fb897a44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb897a44"]])

export default __exports__